import { render, staticRenderFns } from "./BillCardAdditionalInfos.vue?vue&type=template&id=4c767a83&scoped=true&"
import script from "./BillCardAdditionalInfos.vue?vue&type=script&lang=ts&"
export * from "./BillCardAdditionalInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c767a83",
  null
  
)

export default component.exports